import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'reactstrap'
import InputNumber from 'antd/lib/input-number'
import CheckBox from './CheckBox'
import { isDefined } from '@/utils/isDefined'
import { preparePercentageValue } from '@/utils/numberUtilities'
import { useLocalization } from '@/hooks/localization'

const basicPropTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string
}

const integerReplacement = (v) => {
  return v.replace(/[^0-9-]/g, '').replace(/(?!^)-/g, '')
}
const percentageReplacement = (v) => {
  return v.replace('%', '')
}

const numberSanitize = (v) => {
  return typeof v === 'string' ? parseFloat(v.replace(/[^0-9.-]/g, '')) : v
}

const NumericInput = React.memo(function NumericInput ({ percentage, integerOnly, ...otherProps }) {
  const { localize } = useLocalization()
  const value = numberSanitize(otherProps.value)
  if (percentage) { return <PercentageNumericInput {...otherProps} integerOnly /> }
  return <InputNumber
    title={localize('Common.NumericInputOnly')}
    parser={integerOnly ? integerReplacement : undefined}
    max={otherProps.maxValue || 2147483647}
    min={-2147483648}
    value={value}
    {...otherProps}
  />
})
const percentageFormatter = (val) => `${val}%`

function PercentageNumericInput ({ defaultValue, onChange, value, ...otherProps }) {
  const [numValue, setNumValue] = React.useState(preparePercentageValue(value || defaultValue, otherProps))
  const handleBlur = React.useCallback(() => onChange(isDefined(numValue) ? numValue / 100 : numValue), [numValue, onChange])

  return <InputNumber
    formatter={percentageFormatter}
    parser={otherProps.integerOnly ? integerReplacement : percentageReplacement}
    value={numValue}
    onChange={setNumValue}
    onBlur={handleBlur}
    {...otherProps}
  />
}
NumericInput.propTypes = {
  ...basicPropTypes,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  percentage: PropTypes.bool,
  showPlain: PropTypes.bool,
  integerOnly: PropTypes.bool
}

export {
  Input,
  NumericInput,
  CheckBox,
  integerReplacement
}



// WEBPACK FOOTER //
// ./src/components/inputs.js